import React from 'react'
import compose from 'recompose/compose'
import { connect as connectStaticText } from 'components/StaticText/connect'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'

function NotificationsWatchNow (props) {
  const { staticText } = props
  return (
    <div className="notifications-watch-now">
      <IconV2
        className="notifications-watch-now__play"
        type={ICON_TYPES.PLAY}
      />
      <span className="notifications-watch-now__label">
        {staticText.getIn(['data', 'watchNow'])}
      </span>
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'notificationsWatchNow' }),
)(NotificationsWatchNow)
